@if (context?.yesNoText) {
  <div class="default-body-item">
    <h2>{{ context.yesNoText | translate }}</h2>
  </div>
}

@if (isLoading$ | async; as isLoading) {
  <div
    [myreSpinLoader]="isLoading"
    [class.loading]="isLoading"
    class="default-body-item"
  ></div>
} @else {
  <div class="default-body-item">
    @if ((hasVisibleElement$ | async) && context.formGroup) {
      <form [attr.myre-form-id]="context.key">
        <myre-form
          [formGroup]="context.formGroup"
          [elements]="context.elements | async"
        />
      </form>
    }
  </div>
}
